import Language from '~/boot/language-boot'

export default {
  key: "max-length",
  errorMessage: Language.get('validation.errors.max-length'),
  validate(value, args) {
    return value.toString()
      .length <= parseInt(args[0]);
  }
}